import type { ReactNode } from 'react';

interface SkeletonProps {
  className?: string;
  /** When provided with `isLoading={false}`, renders these children instead of the placeholder. */
  children?: ReactNode;
  /** Defaults to `true` — set `false` once real content is ready to swap in. */
  isLoading?: boolean;
}

// Loading placeholder — skeleton over spinner (P10 §2.3). A pulsing glass
// block sized by the caller via className (h-*, w-*). Respects
// prefers-reduced-motion by disabling the pulse animation.
export function Skeleton({ className = '', children, isLoading = true }: SkeletonProps): JSX.Element {
  if (!isLoading && children !== undefined) return <>{children}</>;

  return (
    <div
      aria-hidden
      className={`motion-reduce:animate-none animate-pulse rounded-xl bg-muted ${className}`}
    />
  );
}
